import { makeContextModule } from '@cian/react-utils';

import { INotAvailablePopup } from '../types/notAvailablePopup';

export const { Context: NotAvailablePopupContext, useContext: useNotAvailablePopupContext } =
  makeContextModule<INotAvailablePopup>({
    contextName: 'NotAvailablePopupContext',
  });
